export default __webpack_public_path__ + "static/media/Atelie-das-Artes.c2be17bb.jpg";